import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { SearchAddressSchema } from "src/models/findMapAddress/autocompleteSearchAddress";
import { AddressPlacemarkState } from "src/components/ReservationProduct/ReservationProduct";
import { Box } from "@mui/system";

interface AddressAutocompleteParams {
  isOpenMap: boolean;
  setAddressPlacemark: (state: AddressPlacemarkState | null) => void;
  setCoords: (addressCoords: [number, number]) => void;
  addressList: SearchAddressSchema[];
  setSelectedAddressPharmacy: React.Dispatch<React.SetStateAction<string>>;
}

const AddressAutocomplete: React.FC<AddressAutocompleteParams> = ({
  isOpenMap,
  setAddressPlacemark,
  setCoords,
  addressList,
  setSelectedAddressPharmacy,
}) => {
  return (
    <Autocomplete
      sx={{
        display: "flex",
        width: "300px",
        height: "37px",
        mr: 3,
        boxSizing: "border-box",
        ".MuiOutlinedInput-root": {
          maxHeight: "37px",
        },
      }}
      isOptionEqualToValue={(option, value) =>
        value.display_name === value.display_name
      }
      options={addressList || []}
      noOptionsText={"Ничего не выбрано"}
      getOptionLabel={(option) => option.display_name}
      renderOption={(props, option) => (
        <Box component="li" {...props} key={option.id}>
          {option.pharm_name}
          <br />
          {option.display_name}
        </Box>
      )}
      filterOptions={(options, state) =>
        options.filter((option) => {
          const filteredAddressName = option.display_name
            .toLowerCase()
            .includes(state.inputValue.toLowerCase().trim());

          if (option.pharm_name) {
            const filteredPharmName = option?.pharm_name
              .toLowerCase()
              .includes(state.inputValue.toLowerCase().trim());

            return filteredAddressName || filteredPharmName;
          }
          return filteredAddressName;
        })
      }
      autoComplete
      includeInputInList
      onChange={(e, value, reason) => {
        if (value) {
          setSelectedAddressPharmacy(value.display_name);
          if (!isOpenMap) {
            setAddressPlacemark(AddressPlacemarkState.hide);
            setCoords([value.latitude, value.longitude]);
          }
        }
      }}
      onInputChange={(event, value, reason) => {
        if (reason === "clear") setSelectedAddressPharmacy("");
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Найти по адресу"
          size="small"
          variant="outlined"
        />
      )}
    />
  );
};

export default AddressAutocomplete;
